import { render, staticRenderFns } from "./QuickBetDetail.vue?vue&type=template&id=e9ae57e2&scoped=true"
import script from "./QuickBetDetail.vue?vue&type=script&lang=js"
export * from "./QuickBetDetail.vue?vue&type=script&lang=js"
import style0 from "./QuickBetDetail.vue?vue&type=style&index=0&id=e9ae57e2&prod&lang=css"
import style1 from "./QuickBetDetail.vue?vue&type=style&index=1&id=e9ae57e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ae57e2",
  null
  
)

export default component.exports